module.exports = __webpack_public_path__ + "img/requestpos.1acb5278.svg";